<div class="sidebars">

  
  <!-- TOP BAR -->
 

 <div class="sidebar-header">
  <!-- Close Button -->
  <button class="icon-btn"  (click)="onClose()">
    <img [src]="icons.close" style="height: 30px!important;" alt="Close" />
  </button>

  <!-- Divider -->
  <div class="divider"></div>
  <!-- Help -->
  <!-- <button class="icon-btn">
    <img [src]="icons.help" alt="Help" />
  </button> -->

  <!-- Notification -->
  <button (click)="onClose()" class="icon-btn notification" routerLink="/app/notifications">
    <img [src]="icons.bell" alt="Notifications" />
    <span class="dot"></span>
  </button>

  <!-- User Info -->
  <div class="user-info">
    <img [src]="user.image" alt="Profile" class="profile-img" />
    <div class="details">
      <div class="user-name">{{ userDetails?.name }}</div>
      <!-- <div class="user-role">{{ user.role }}</div> -->
    </div>
  </div>
</div>


  <!-- MENU -->
  <ul class="menu-list">
    <li *ngFor="let item of menuItems" class="menu-item">
      <a [routerLink]="item.path" routerLinkActive="active" (click)="onClose()">
        <img [src]="item.icon" alt="">
       
        <span>{{ item.title }}</span>
      </a>
    </li>
  </ul>

  <!-- LOGOUT BUTTON -->
  <div class="logout-section">
    <button (click)="logout()" style="
      font-size: 14px;" class="btn w-100">
      <img src="/assets/img/logout-icon.svg" class="w"  alt=""> Logout
    </button>
  </div>
</div>
